import { currencies, modifiers } from './pricePages';

const pricePath = (metal, currency, modifier) => (
  `/price/${metal}/${currency}${modifier ? `/${modifier}` : ''}`
);

const makeLink = (label, metal, currency, modifier) => ({
  label,
  to: pricePath(metal, currency, modifier)
});

const isValidPriceLink = (metal, currency, modifier) => (
  currencies[currency] && (!modifier || modifiers[modifier])
);

const uniqueLinks = (links) => {
  const seen = {};

  return links.filter((link) => {
    if (seen[link.to]) {
      return false;
    }

    seen[link.to] = true;
    return true;
  });
};

export const popularFooterPriceLinks = [
  makeLink('Gold Price API', 'XAU', 'USD'),
  makeLink('Silver Price API', 'XAG', 'USD'),
  makeLink('Platinum Price API', 'XPT', 'USD'),
  makeLink('Palladium Price API', 'XPD', 'USD'),
  makeLink('Gold Price in AUD', 'XAU', 'AUD'),
  makeLink('Gold Price in EUR', 'XAU', 'EUR'),
  makeLink('Gold Price in AED', 'XAU', 'AED'),
  makeLink('Live Gold Price API', 'XAU', 'USD', 'live'),
  makeLink('Free Gold Price API', 'XAU', 'USD', 'free'),
  makeLink('Gold Historical Data API', 'XAU', 'USD', 'historical'),
  makeLink('Gold JSON API', 'XAU', 'USD', 'json'),
  makeLink('Gold API Python Example', 'XAU', 'USD', 'python')
];

export const homepagePriceLinks = [
  makeLink('Gold Price API', 'XAU', 'USD'),
  makeLink('Silver Price API', 'XAG', 'USD'),
  makeLink('Gold Price in AUD', 'XAU', 'AUD'),
  makeLink('Gold Price in AED', 'XAU', 'AED'),
  makeLink('Live Gold Price API', 'XAU', 'USD', 'live'),
  makeLink('Free Gold Price API', 'XAU', 'USD', 'free'),
  makeLink('Historical Gold Price API', 'XAU', 'USD', 'historical'),
  makeLink('Gold API for Python', 'XAU', 'USD', 'python')
];

export const getRelatedPriceLinks = (page) => {
  const metalCode = page.metal.code;
  const currencyCode = page.currency.code;
  const metalName = page.metal.name;
  const currentPath = pricePath(metalCode, currencyCode, page.pathModifier);

  const currencyLinks = ['USD', 'AUD', 'EUR'].map((currency) => (
    makeLink(`${metalName} Price in ${currency}`, metalCode, currency)
  ));

  const modifierLinks = [
    makeLink(`Live ${metalName} Price API`, metalCode, currencyCode, 'live'),
    makeLink(`Free ${metalName} Price API`, metalCode, currencyCode, 'free'),
    makeLink(`Historical ${metalName} Data API`, metalCode, currencyCode, 'historical'),
    makeLink(`${metalName} JSON API`, metalCode, currencyCode, 'json'),
    makeLink(`${metalName} API for Python`, metalCode, currencyCode, 'python')
  ];

  return uniqueLinks([...currencyLinks, ...modifierLinks]).filter((link) => {
    const [, , metal, currency, modifier] = link.to.split('/');
    return link.to !== currentPath && isValidPriceLink(metal, currency, modifier);
  });
};
